import { action as apiAction } from 'api/Api'
import { setName } from '../redux/labels'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  name: string
}

export default (payload: Payload) => async dispatch => {
  const { id, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setName({
    labelId: id,
    name: name.trim()
  }))

  try {
    await apiAction('RenameLabel', {
      id,
      name: name.trim()
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
